import axios from "axios";
import React, {useEffect, useState} from "react";
import Swal from 'sweetalert2';
import ERPDataGrid from "../ERPDataGrid";
import "../ERPTheme.css";
import {baseUrl, ipAddress, userName} from '../Univ';
function AddLandOwner() {
    const [rows, setRows] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [formData, setFormData] = useState({
        name: "",
        mobile: "",
        address: "",
        pincode: ""
    });
    /* ---------------- HANDLE CHANGE ---------------- */
    const handleChange = (e) => {
        setFormData({...formData, [e.target.name]: e.target.value});
    };
    /* ---------------- SUBMIT ---------------- */
    const formSubmit = (e) => {
        e.preventDefault();
        if (!formData.mobile || !formData.pincode) {
            Swal.fire("Error", "Fill required fields", "error");
            return;
        }
        const fd = new FormData();
        fd.append("name", formData.name);
        fd.append("mobile", formData.mobile);
        fd.append("address", formData.address);
        fd.append("pincode", formData.pincode);
        fd.append("status", "1");
        fd.append("addedby", userName);
        fd.append("ip_add", ipAddress);
        axios.post(baseUrl + "land-owner/create/", fd)
            .then(() => {
                Swal.fire("Success", "Land Owner Added", "success");
                window.location.reload();
            })
            .catch(() => {
                Swal.fire("Error", "Something went wrong", "error");
            });
    };
    /* ---------------- FETCH ---------------- */
    const fetchData = () => {
        setIsLoading(true);
        axios.get(baseUrl + "land-owner/create/")
            .then(res => {
                setRows(res.data);
                setIsLoading(false);
            });
    };
    useEffect(() => {
        fetchData();
    }, []);
    /* ---------------- COLUMNS ---------------- */
    const columns = [
        {field: "id", headerName: "ID", width: 80},
        {field: "name", headerName: "Name", width: 150},
        {field: "mobile", headerName: "Mobile", width: 150},
        {field: "address", headerName: "Address", width: 120},
        {field: "pincode", headerName: "Pincode", width: 120},
        {
            field: "delete",
            headerName: "Action",
            width: 100,
            renderCell: (params) => (
                <button
                    className="btn btn-danger btn-sm"
                    onClick={() => handleDelete(params.row.id)}
                >
                    Delete
                </button>
            )
        }
    ];
    const handleDelete = (id) => {
        Swal.fire({
            title: 'Confirm',
            text: 'Are you Sure you want to delete this',
            icon: 'info',
            confirmButtonText: 'Continue',
            showCancelButton: true
        }).then((result) => {
            if (result.isConfirmed) {
                try {
                    axios.delete(baseUrl + 'delete-owner/' + id + '/')
                        .then(function (response) {
                            Swal.fire('success', 'Data has been Deleted');
                            window.location.reload();
                        });
                } catch (error) {
                    Swal.fire('error', 'Data has not been deleted');
                }
            } else {
                Swal.fire('error', 'Data has not been deleted');
            }
        })
    }
    return (
        <section className="container mt-4">

            <div className="card">
                <h4 className="card-header">Add Land Owner</h4>

                <div className="card-body">

                    <input
                        name="name"
                        value={formData.name}
                        placeholder="Name"
                        className="form-control mb-2"
                        onChange={handleChange}
                    />

                    <input
                        type="number"
                        name="mobile"
                        value={formData.mobile}
                        placeholder="Mobile"
                        className="form-control mb-2"
                        onChange={handleChange}
                    />

                    <input
                        name="address"
                        value={formData.address}
                        placeholder="Address"
                        className="form-control mb-2"
                        onChange={handleChange}
                    />

                    <input
                        type="number"
                        name="pincode"
                        value={formData.pincode}
                        placeholder="Pincode"
                        className="form-control mb-2"
                        onChange={handleChange}
                    />

                    <button onClick={formSubmit} className="btn btn-primary">
                        Submit
                    </button>

                </div>
            </div>

            {/* TABLE */}

            <ERPDataGrid
                sx={{
                    boxShadow: 4,
                    border: 4,
                    borderColor: 'primary.light',
                    '& .MuiDataGrid-cell:hover': {
                        color: 'primary.main',
                    },
                }}
                className="mt-4"
                rows={rows}
                columns={columns}

                autoHeight
                loading={isLoading}
            />

        </section>
    );
}
export default AddLandOwner;
